import { format } from "date-fns";

import { PRODUCT_NAME } from "@src/shared/brand";

const PRODUCT_SLUG = PRODUCT_NAME.singular.toLowerCase();

export const TwoFactorEntity = {
  toBackupCodesFilename(generatedAt: Date = new Date()): string {
    return `${PRODUCT_SLUG}-backup-codes-${format(generatedAt, "yyyy-MM-dd")}.txt`;
  },

  /**
   * The saved file has to stand on its own months later, when the user opens it
   * after losing their authenticator, so it repeats what the codes are for.
   */
  toBackupCodesFileContents(
    codes: string[],
    generatedAt: Date = new Date(),
  ): string {
    return [
      `${PRODUCT_NAME.singular} two-factor backup codes`,
      `Generated ${format(generatedAt, "yyyy-MM-dd")}`,
      "",
      "Each code signs you in once if you lose access to your authenticator",
      "app. Keep this file somewhere safe, and don't share it.",
      "",
      ...codes,
      "",
    ].join("\n");
  },

  downloadBackupCodes(codes: string[], generatedAt: Date = new Date()): void {
    const file = new Blob(
      [this.toBackupCodesFileContents(codes, generatedAt)],
      { type: "text/plain;charset=utf-8" },
    );
    const fileUrl = URL.createObjectURL(file);
    const link = document.createElement("a");

    link.href = fileUrl;
    link.download = this.toBackupCodesFilename(generatedAt);
    document.body.appendChild(link);

    try {
      link.click();
    } finally {
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(fileUrl), 60_000);
    }
  },
} as const;
